import React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { BACKEND_DATE_FORMAT } from 'config/Vars'
import { GetTrainingInsightsDocument, InsightsPageDataDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Body } from 'modules/trainings/components/Insights/Body'
import { Filters } from 'modules/trainings/components/Insights/Filters'
import { Provider } from 'modules/trainings/hooks/Insights/useFilters'

const Insights = () => {
  const lastMonth = moment().subtract(1, 'month')
  const startDate = lastMonth.startOf('month').format(BACKEND_DATE_FORMAT)
  const endDate = lastMonth.endOf('month').format(BACKEND_DATE_FORMAT)
  const { loading: loadingPage, data, error } = useQuery(InsightsPageDataDocument)
  const authorized =
    data?.trainings._policies.trainingsAccessManagementSpace.can &&
    data?.trainings._policies.insightRead.can
  const trainings = data?.trainings.trainings || []
  const teams = data?.teams.teams || []

  const [dateRange, setDateRange] = React.useState<[string | undefined, string | undefined]>([
    startDate,
    endDate,
  ])
  const [trainingIds, setTrainingIds] = React.useState<number[]>([])
  const [trainingClassesIds, setTrainingClassesIds] = React.useState<number[]>([])
  const [teamIds, setTeamIds] = React.useState<number[]>([])
  const { loading: loadingData, data: insightsData } = useQuery(GetTrainingInsightsDocument, {
    variables: {
      from: dateRange[0],
      to: dateRange[1],
      trainingIds,
      trainingClassesIds,
      teamIds,
    },
  })
  const insights = insightsData?.trainings.insights[0]

  track(trackingEvents.training.openTrainingInsights)

  return (
    <ResponsivePage.Body variant="full" authorized={authorized} loading={loadingPage} error={error}>
      <Box height="full">
        <Box gap="s16">
          <Provider
            value={{
              dateRange,
              setDateRange,
              trainingIds,
              setTrainingIds,
              trainingClassesIds,
              setTrainingClassesIds,
              teamIds,
              setTeamIds,
            }}
          >
            {!loadingData && <Filters trainings={trainings} teams={teams} />}
            {loadingData && (
              <Box alignItems="center" height="full">
                <Spinner />
              </Box>
            )}
            {!loadingData && insights && <Body insights={insights} />}
          </Provider>
        </Box>
      </Box>
    </ResponsivePage.Body>
  )
}

export default Insights
